import { render, staticRenderFns } from "./Saving.vue?vue&type=template&id=36859536&scoped=true&"
var script = {}
import style0 from "./Saving.vue?vue&type=style&index=0&id=36859536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36859536",
  null
  
)

export default component.exports